import PriceSummary from "./Components/PriceSummary";
import PromoCode from "./Components/PromoCode";

const PaymentStep = ({ data, setData, total, promoState, applyPromo, next,isPromoLocked }) => {
  return (
    <div className="checkout-content">
      <div>
        <h3>Apply Discounts</h3>

        <PromoCode
          value={data.promoCode}
          onChange={(val) =>
            setData((prev) => ({ ...prev, promoCode: val }))
          }
          onApply={applyPromo}
          state={promoState}
          disabled={isPromoLocked}
        />
      </div>

      <PriceSummary
        price={data.price}
        discount={data.discount}
        total={total}
        onNext={next}
      />
    </div>
  );
};

export default PaymentStep;